import React, { useState, useEffect } from 'react'

import {
	Button,
	Chip,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { makeStyles, ThemeProvider } from '@material-ui/core/styles'
import { useHistory, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { selectChip } from '../../services/theme'
import parse from 'autosuggest-highlight/parse'
import match from 'autosuggest-highlight/match'
import moment from 'moment'

const useStyles = makeStyles((theme) => ({
	dialog: {
		'& .MuiDialog-paper': {
			// width: "70%",
			maxWidth: 1000
		}
	},
	formWrapper: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 20
	},
	fieldWrapper: {
		'&:nth-child(odd)': {
			marginRight: '25px'
		},
		display: 'flex',
		flexDirection: 'column',
		marginBottom: '20px'
	},
	dialogActions: {
		justifyContent: 'flex-start'
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: '6px',
		backgroundColor: 'transparent !important'
	},
	chip: {
		marginRight: 2
	},
	tableRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		padding: 5
	},
	close: {
		position: 'absolute',
		top: 10,
		right: 10,
		padding: 10,
		fontFamily: 'Nunito',
		fontWeight: '800',
		fontSize: 12,
		cursor: 'pointer'
	},
	cell: {
		width: '20%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		'& h5': {
			fontFamily: 'Nunito',
			fontWeight: '800',
			fontSize: 12,
			margin: 0,
			marginBottom: 3
		},
		'& span': {
			fontFamily: 'Nunito',
			fontSize: 16
		}
	},
	title: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		width: '100%',
		'& h4': {
			margin: 0,
			fontFamily: 'Nunito',
			fontWeight: '800',
			fontSize: 16,
			lineHeight: '22px'
		},
		'& i': {
			marginRight: 10,
			color: '#777679'
		}
	},
	petRow: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'center',
		paddingTop: 15,
		width: '100%',
		'& img': {
			height: 50,
			width: 50,
			borderRadius: 25,
			marginRight: 15
		},
		'& h4': {
			fontFamily: 'Nunito',
			fontWeight: '800',
			fontSize: 16
		}
	}
}))

const StaffDialog = (props) => {
	const classes = useStyles()
	const history = useHistory()
	const facility = useSelector((state) => state.specific.facilities.selected)
	const visit = useSelector((state) => state.specific.visits.selected)
	const occurences = ['Daily', 'Every Day', 'Every Other Day', 'Custom']
	const timeBlocks = ['morning', 'midday', 'evening']

	const { save, isShown, setIsShown, saveAddOn, addOn, pet, visits, saveStaff, setStaff, group } = props

	return (
		<Dialog
			open={isShown}
			aria-labelledby="form-dialog-title"
			className={classes.dialog}
			onClose={() => setIsShown(false)}>
			<DialogTitle>STAFF ASSIGNMENTS</DialogTitle>
			<DialogContent>
				<span className={classes.close} onClick={() => setIsShown(false)}>
					X
				</span>
				<div className={classes.formWrapper}>
					<div className={classes.petRow}>
						<div className={classes.title}>
							<i className="fal fa-sunrise" />
							<h4>Morning Shift</h4>
						</div>
						<Autocomplete
							multiple
							id="tags-standard"
							options={props.staff || []}
							value={
								group && group.staff && group.staff.morning
									? group.staff.morning.map((id) => {
											return props.staff.find((s) => s._id == id)
									  })
									: []
							}
							getOptionLabel={(option) => {
								return option ? `${option.first_name} ${option.last_name}` : 'wat'
							}}
							onChange={(e, val) => {
								setStaff(
									val.map((v) => v._id),
									'morning',
									group
								)
							}}
							renderInput={(params) => (
								<TextField {...params} variant="standard" placeholder="Available Staff" />
							)}
							renderOption={(option, { inputValue }) => {
								const matches = match(`${option.first_name} ${option.last_name}`, inputValue)
								const parts = parse(`${option.first_name} ${option.last_name}`, matches)

								return (
									<div>
										{parts.map((part, index) => (
											<span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
												{part.text}
											</span>
										))}
									</div>
								)
							}}
						/>
					</div>
					<div className={classes.petRow}>
						<div className={classes.title}>
							<i className="fa fa-sun" />
							<h4>Afternoon Shift</h4>
						</div>
						<Autocomplete
							multiple
							value={
								group && group.staff && group.staff.afternoon
									? group.staff.afternoon.map((id) => {
											return props.staff.find((s) => s._id == id)
									  })
									: []
							}
							id="tags-standard"
							options={props.staff}
							getOptionLabel={(option) => `${option.first_name} ${option.last_name}`}
							renderInput={(params) => (
								<TextField {...params} variant="standard" placeholder="Available Staff" />
							)}
							onChange={(e, val) =>
								setStaff(
									val.map((v) => v._id),
									'afternoon',
									group
								)
							}
							renderOption={(option, { inputValue }) => {
								const matches = match(`${option.first_name} ${option.last_name}`, inputValue)
								const parts = parse(`${option.first_name} ${option.last_name}`, matches)

								return (
									<div>
										{parts.map((part, index) => (
											<span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
												{part.text}
											</span>
										))}
									</div>
								)
							}}
						/>
					</div>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				{/* <Button
          variant="contained"
          onClick={ createAddOn }
          color="secondary"
        >
          Apply
        </Button> */}
				<Button variant="outlined" onClick={() => saveStaff(group.staff)} color="secondary">
					SAVE
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default StaffDialog
